import React from 'react'
import { BeatLoader } from  'react-spinners'

export default function Loader() {
    return (
        <BeatLoader color="#ffff" size="10px" />

    )
}
